import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Box, Card, CardContent, Typography } from '@mui/material';

import { BLACK } from '../../../../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../../../../theme/fontConstants';
import { getDocumentTitle, getStatusUi } from '../documentDisplay';

import DocumentCard from './DocumentCard';

const sectionTitleSx = {
  fontFamily: PRIMARY_FONT[500],
  fontSize: '14px',
  lineHeight: '100%',
  letterSpacing: '0%',
  color: BLACK[100],
  px: 2,
  py: 1.25,
  borderBottom: `1px solid ${BLACK[30]}`,
};

const emptyStateSx = {
  px: 2,
  py: 1.5,
};

const emptyStateTextSx = {
  fontFamily: PRIMARY_FONT[400],
  fontSize: '12px',
  color: BLACK[60],
};

const DocumentSection = ({
  titleKey,
  documents,
  activeActionKey,
  onView,
  onUploadHistory,
  onRequestFormStatus,
  onRequestFormValidity,
  onRequestSetExpiration,
}) => (
  <Card variant="outlined" sx={{ borderRadius: '16px', mb: 2 }}>
    <Typography sx={sectionTitleSx}>{LanguageConverterV2(titleKey)}</Typography>
    <CardContent sx={{ p: 0 }}>
      {documents.map((document) => {
        const statusUi = getStatusUi(document?.state?.status);

        return (
          <Box key={document._id} sx={{ borderBottom: `1px solid ${BLACK[30]}` }}>
            <DocumentCard
              document={document}
              title={getDocumentTitle(document)}
              statusLabel={LanguageConverterV2(statusUi.statusLabelKey)}
              statusText={LanguageConverterV2(statusUi.statusTextKey)}
              statusVariant={statusUi.statusVariant}
              submittedAtEpoch={document?.metadata?.modifiedAt}
              isActionLoading={activeActionKey === `view:${document._id}`}
              onView={() => onView(document._id)}
              onUploadHistory={() => onUploadHistory(document?.documentType)}
              onSelectFormStatus={onRequestFormStatus}
              onSelectFormValidity={onRequestFormValidity}
              onSelectSetExpiration={onRequestSetExpiration}
            />
          </Box>
        );
      })}

      {documents.length === 0 && (
        <Box sx={emptyStateSx}>
          <Typography sx={emptyStateTextSx}>
            {LanguageConverterV2('userDetail.employeeDocumentation.emptySection')}
          </Typography>
        </Box>
      )}
    </CardContent>
  </Card>
);

DocumentSection.propTypes = {
  activeActionKey: PropTypes.string,
  documents: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string,
      documentType: PropTypes.string,
      metadata: PropTypes.shape({
        createdAt: PropTypes.number,
        modifiedAt: PropTypes.number,
      }),
      state: PropTypes.shape({ status: PropTypes.string }),
      validity: PropTypes.shape({
        status: PropTypes.string,
        range: PropTypes.shape({
          validFrom: PropTypes.string,
          validNoticeFrom: PropTypes.string,
          validThrough: PropTypes.string,
        }),
      }),
    })
  ),
  onRequestFormStatus: PropTypes.func,
  onRequestFormValidity: PropTypes.func,
  onRequestSetExpiration: PropTypes.func,
  onUploadHistory: PropTypes.func,
  onView: PropTypes.func,
  titleKey: PropTypes.string.isRequired,
};

DocumentSection.defaultProps = {
  activeActionKey: null,
  documents: [],
  onRequestFormStatus: () => {},
  onRequestFormValidity: () => {},
  onRequestSetExpiration: () => {},
  onUploadHistory: () => {},
  onView: () => {},
};

export default DocumentSection;
